import { render, staticRenderFns } from "./NLTable.vue?vue&type=template&id=1a39bb51&scoped=true&"
import script from "./NLTable.vue?vue&type=script&lang=js&"
export * from "./NLTable.vue?vue&type=script&lang=js&"
import style0 from "./NLTable.vue?vue&type=style&index=0&id=1a39bb51&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a39bb51",
  null
  
)

export default component.exports